module.exports = new __parcel__URL__("combined.f637b25d.svg").toString();